<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 0 32 32">
    <path
      fill-rule="evenodd"
      d="M14 0h-2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm10 16h-2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V18a2 2 0 0 0-2-2ZM4 9H2a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2Z"
    />
  </svg>
</template>